export default ['GREEN', 'YELLOW', 'ORANGE'];
